import { Box } from '@mui/material';
import { VideoCard } from '../../components/VideoCard/VideoCard';
import { useWindowSize } from '../../hooks/useWindowSize/useWindowSize';
import { Loading } from '../../components/Loading/Loading';
import { useState } from 'react';
import { mediaContainerSx } from '../../styles/Global.style';
import { PageContainer } from '../../containers/PageContainer/PageContainer';
import { Copy } from '../../copy/Copy';
import { useVideoData } from '../../hooks/useVideoData/useVideoData';
import { DEFAULT_VIDEO } from '../../constants/videos';

export const Videos = () => {
  const { windowSize } = useWindowSize();
  const isMobile = windowSize.width <= 666;
  const { videos, isVideosLoading } = useVideoData();
  const [isLoading, setIsLoading] = useState(true);
  const isDataAndPageLoading = isVideosLoading || isLoading;

  const onLoad = () => {
    setTimeout(() => {
      setIsLoading(false);
    }, 1000);
  };

  return (
    <PageContainer title={Copy.generate('Global.videos')}>
      {isDataAndPageLoading && <Loading />}

      <Box component="section" sx={mediaContainerSx(isMobile)}>
        {videos?.map((v, i) => (
          <VideoCard
            key={i}
            videoId={v.id}
            youtubeId={v.youtubeId}
            userId={v.userId}
            onLoad={onLoad}
            visibility={isLoading ? 'hidden' : 'visible'}
          />
        ))}

        {!isVideosLoading && (
          <VideoCard
            videoId={DEFAULT_VIDEO.defaultId}
            youtubeId={DEFAULT_VIDEO.youtubeId}
            userId={DEFAULT_VIDEO.defaultId}
            onLoad={onLoad}
            visibility={isLoading ? 'hidden' : 'visible'}
          />
        )}
      </Box>
    </PageContainer>
  );
};
